<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <b-row>
                        <b-col cols="8">
                            <b-row>
                                <b-col cols="6" lg="6" md="6" sm="12">

                                    <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativaSMTarefa"
                                        @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                                        invalidFeedback="Informe uma unidade administrativa!"
                                        :prefix="prefix + title + ' > '" label="UA-Solicitante:" />

                                </b-col>
                                <b-col cols="6" lg="6" md="6" sm="12">
                                    <lg-form-input invalidFeedback="O número processo deve ser informado!"
                                        description="" v-model="form.numero" label="Número:" cols="12" />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6" lg="6" md="6" sm="12">

                                    <lg-finder-page-pessoa :prefix="prefix + title + ' > '" v-model="form.responsavel"
                                        id="finderPessoaTarefaSolicitacaoManutencao" @onselect="selectResponsavel"
                                        label="Responsável:" />


                                </b-col>
                                <b-col cols="6" lg="6" md="6" sm="12">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-row>
                                                <b-col cols="6">
                                                    <lg-form-date invalidFeedback="A data de deve ser informada!"
                                                        description="" v-model="form.dataDe" label="De:" cols="12" />
                                                </b-col>
                                                <b-col cols="6">
                                                    <lg-form-date invalidFeedback="A data limite deve ser informada!"
                                                        description="" v-model="form.dataAte" label="Até:" cols="12" />
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="6">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-row>
                                                <b-col cols="6">
                                                    <lg-form-input invalidFeedback="Informe uma nota fiscal válida!"
                                                        description="" v-model="form.numTombamento" label="Tombamento:"
                                                        cols="12" />
                                                </b-col>
                                                <b-col cols="6">
                                                    <lg-form-input invalidFeedback="O ate deve ser informado!"
                                                        description="" v-model="form.ate" label="Até:" cols="12" />
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="6">
                                    <lg-form-select v-model="form.status" :loadFunction="statusList"
                                        labelFormGroupBind="Status:" label="descricao" cols="12" description=" "
                                        filterList="true" />
                                </b-col>
                                <b-col cols="6">
                                    <lg-form-input invalidFeedback="Informe uma nota fiscal válida!" description=""
                                        v-model="form.numTombamentoSamp" label="Tombamento SAMP:" cols="12" />
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="4" class="d-flex align-self-center justify-content-center">
                            <b-row>
                                <b-col cols="12">
                                    <b-button id="LimparTM" class="my-2" size="sm" style="height: 40px" pill
                                        variant="primary" @click="limpar">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="eraser" />
                                        </div>
                                        <b-tooltip target="limpar" title="LimparTM"></b-tooltip>
                                    </b-button>

                                    <b-button id="loadSM" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                        variant="primary" @click="load()">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="search" />
                                        </div>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>

                    <template #empty>
                        <p class="text-center">Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(wrench)="{ item }">
                        <b-button v-if="item.status.id !== 238" @click="showModalTipoDeManutencao(item)"
                            class="text-dark p-0 mx-1" variant="primary" title="Tipo De Manutencão">
                            <b-icon icon="wrench" />
                        </b-button>
                    </template>
                    <template v-slot:cell(aguardando)="{ item }">
                        <b-button v-b-tooltip.hover.top="'Aguardando'" :disabled="item.status.id == 232 || item.status.id == 235 || item.status.id == 236 || item.status.id == 237"
                            :variant="item.status.id != 234 ? 'danger' : 'primary'">
                            A
                        </b-button>
                    </template>

                    <template v-slot:cell(emAtendimento)="{ item }">

                        <b-button
                            @click="function () { if (item.status.id != 234) return; showModalEmAtendimento(item.id) }"
                            :variant="item.status.id == 234 ? 'danger' : 'primary'"
                            v-b-tooltip.hover.top="'Em atendimento'"
                            :disabled="item.status.id !== 234 && item.status.id !== 235 ">
                            EA
                        </b-button>
                    </template>

                    <template v-slot:cell(recolhido)="{ item }">
                        <b-button @click="function () { if (item.status.id != 235) return; showModalRecolhido(item) }"
                            :variant="item.status.id == 235 ? 'danger' : 'primary'" v-b-tooltip.hover.top="'Recolhido'"
                            :disabled="item.status.id !== 235 && item.status.id !== 236">
                            R
                        </b-button>
                    </template>

                    <template v-slot:cell(movimentado)="{ item }">
                        <b-button
                            @click="function () { if (item.status.id == 237) return; showESendModalMovimentado(item) }"
                            :variant="item.status.id == 235 || item.status.id == 236 ? 'danger' : 'primary'"
                            v-b-tooltip.hover.top="'Movimentado'"
                            :disabled="item.status.id !== 235 && item.status.id !== 236 && item.status.id !== 237">
                            M
                        </b-button>
                    </template>

                    <template v-slot:cell(finalizado)="{ item }">
                        <b-button :disabled="item.status.id == 232" @click="showModalFinalizado(item)" variant="danger"
                            title="Finalizado">
                            <span class="circle-icon">F</span>
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <b-modal size="xl" button-size="sm" hide-footer id="ModalTipoManutencao"
            :title="prefix + title + ' > Manutenção de Item Bem Permanente'">
            <TipoDeManutencaoList :prefix="prefix + title + ' > '" :mostrarAdicionar="true"
                :idSolicitacao='idSolicitacao' />
        </b-modal>

    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import TipoDeManutencaoList from "./TipoDeManutencaoList.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"

import moment from "moment"
import Swal from "sweetalert2"

export default {
    name: "TarefaManutencaoList",

    components: {
        LgFinderPagePessoa,
        LgFinderPageUnidadeAdministrativa,
        LgFormInput,
        LgFormDate,
        LgFormSelect,
        TipoDeManutencaoList,
    },

    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Solicitação Manutenção"
        },
        id: String,
        onselect: Function,
        value: Object,
    },

    data() {
        return {
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            total: 0,
            totalPage: 0,
            busy: false,
            records: [],
            filtro: "",
            TarefaSelected: null,
            form: {
                id: "",
                dataDe: "",
                dataAte: "",
                ate: "",
                status: { id: null, descricao: "Todos" },
                responsavel: {},
                numTombamento: "",
                numTombamentoSamp: "",
                departamento: {},
                numero: "",
                dadosModal: {},
            },
        }
    },
    async beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/62`)
        this.$service = new ResourceService(`/api/tarefasolmanutencao`)

        var { data } = await new ResourceService(`/api/configuracoes-sistema`).get('buscar-responsaveis-manutencao')

        const partes = data.split(";");
        this.departamentoResponsavel = partes[0];
        this.localResponsavel = partes[1];

    },
    mounted() {
        this.load()
    },
    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        idSolicitacao() {
            return this.TarefaSelected ? this.TarefaSelected.idSolicitacaoManutencao : null;
        },
        tableFields() {
            return [
                { key: "id", label: "Numero" },

                {
                    key: "dhCriacao",
                    label: "Abertura",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },

                {
                    key: "numTombamento",
                    label: " Tomb. SPALM",
                },

                {
                    key: "s_numTombAntigo",
                    label: "Tombamento Samp",
                },

                {
                    key: "descricaoResumida",
                    label: "Descrição",
                },

                {
                    key: "problemaRelatado",
                    label: "Problema Relatado",
                },

                { key: "departamento.sigla", label: "Sigla" },

                { key: "pessoa.nome", label: "Responsavel" },

                { key: "status.descricao", label: "Status" },

                { key: "wrench", label: " " },
                { key: "aguardando", label: " " },

                { key: "emAtendimento", label: " " },

                { key: "recolhido", label: " " },

                { key: "movimentado", label: " " },

                { key: "finalizado", label: " " },
            ]
        },
    },
    methods: {
        limpar() {
            this.form = {
                id: "",
                dataDe: "",
                dataAte: "",
                ate: "",
                status: { id: null, descricao: "Todos" },
                responsavel: {},
                numTombamento: "",
                numTombamentoSamp: "",
                departamento: {},
                numero: "",
                dadosModal: {},
            };
            this.load();
        },
        selectResponsavel(item) {
            this.form.responsavel = item
            this.load()
        },

        handleSelectUnidadeAdministrativa(item) {
            this.form.departamento = item
            this.load()
        },

        async load() {
            this.busy = true
            const params = {
                size: this.perPage,
                page: this.page - 1,
            }

            if (this.form.numero) {
                params.id = this.form.numero
            }

            if (this.form.numTombamento) {
                params.numTombamento = this.form.numTombamento
            }

            if (this.form.ate) {
                params.numTombamentoAte = this.form.ate
            }


            if (this.form.numTombamentoSamp) {
                params.numTombamentoSamp = this.form.numTombamentoSamp
            }

            if (this.form.dataDe) {
                params.dataDe = this.form.dataDe
            }

            if (this.form.dataAte) {
                params.dataAte = this.form.dataAte
            }

            if (this.form.status && this.form.status.id) {
                params.statusId = this.form.status.id
            }

            if (this.form.departamento && this.form.departamento.id) {
                params.departamento = this.form.departamento.id;
            }

            if (this.form.responsavel && this.form.responsavel.id) {
                params.responsavelId = this.form.responsavel.id;
            }

            const response = await this.$service.findAll({ params })
            this.records = response.data.content
            this.total = response.data.totalElements
            this.totalPage = response.data.totalPages

            this.busy = false
        },
        async statusList({ filter, page = 1 }) {
            const status = await this.$statusService.findAll({
                filter,
                page,
                limit: 5,
            })

            const finalizado = status.data.content.find(
                (element) => element.descricao === "finalizado"
            )

            const finalizadoSelect = {
                ...finalizado,
                descricao: "Todos Exceto Finalizado",
                id: 238,
            }
            status.data.content.push(finalizadoSelect)

            const selectTodos = {
                ...finalizado,
                descricao: "Todos",
                id: 235,
            }

            status.data.content.push(selectTodos)

            return status
        },

        async alteraStatus(item, statusId) {
            const { status } = this.$service.alteraStatus(item, statusId)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro de entrada ${status.descricao}!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao alterar status para ${status.descricao}!`,
                })
                item.status = status
            }
        },

        async showModalTipoDeManutencao(item) {
            this.TarefaSelected = item
            this.$bvModal.show("ModalTipoManutencao")
        },

        async showModalTipoDeManutencaoCadastro() {
            this.$bvModal.show(this.modalTipoDeManutencaoCadastroId)
        },

        async showModalEmAtendimento(id) {



            const value = await Swal.fire({
                title: ` Deseja iniciar o atendimento desta solicitação?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/atender`, {});
                this.busy = false;
                this.load()
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: err.response.data,
                })
            }
        },

        async showModalFinalizado({ id }) {
            const value = await Swal.fire({
                title: ` Deseja finalizar o manutenção?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/finalizar`, {})
                this.busy = false;
                this.load()
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: err.response.data,
                })
            }
        },

        async showModalRecolhido({ id }) {
            const value = await Swal.fire({
                title: ` Deseja recolher o item para manutenções sem movimentação? Lembrando que o item permanecera na UA atual.`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/recolher`, {})
                this.busy = false;
                this.load()
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: err.response.data,
                })
            }
        },

        async showESendModalMovimentado({ id }) {
            const value = await Swal.fire({
                title: ` Deseja movimentar o item para manutenções, gerando uma movimentação direta  da UA atual para ${this.departamentoResponsavel} - ${this.localResponsavel} ?`,
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value
            })

            if (!value) {
                return
            }

            try {
                this.busy = true;
                await this.$service.post(`${id}/movimentado`, {})
                this.busy = false;
                this.load()
            } catch (err) {
                this.$notify({
                    type: "danger",
                    message: err.response.data,
                })
            }
        },

    },
}
</script>
